export default {
	"components.Backtrack": "原路退回",
	"components.RefundPath": "退款路径",
	"components.refundAmount": "退款金额"
}